export default __webpack_public_path__ + "static/media/project_lg_autopartes.536d4442.png";